import { render, staticRenderFns } from "./CalendarAppointment.vue?vue&type=template&id=4122b74c&"
import script from "./CalendarAppointment.vue?vue&type=script&lang=js&"
export * from "./CalendarAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports